import supabase from '../config/supabaseClient';

export const paymentMethodService = {
  async getAllPaymentMethods(userId) {
    try {
      const { data, error } = await supabase
        .from('payment_methods')
        .select('*')
        .eq('user_id', userId)
        .order('created_at', { ascending: false });

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Error getting payment methods:', error);
      throw error;
    }
  },

  async createPaymentMethod(paymentMethodData) {
    try {
      if (!paymentMethodData.user_id) {
        throw new Error('User ID is required');
      }

      if (!paymentMethodData.name) {
        throw new Error('Name is required');
      }

      if (!paymentMethodData.type) {
        throw new Error('Type is required');
      }

      const { data, error } = await supabase
        .from('payment_methods')
        .insert([paymentMethodData])
        .select();

      if (error) {
        console.error('Supabase error:', error);
        throw new Error(error.message);
      }

      return data[0];
    } catch (error) {
      console.error('Error creating payment method:', error);
      throw error;
    }
  },

  async deletePaymentMethod(id) {
    try {
      const { error } = await supabase
        .from('payment_methods')
        .delete()
        .eq('id', id);

      if (error) throw error;
    } catch (error) {
      console.error('Error deleting payment method:', error);
      throw error;
    }
  },

  async getPaymentMethodCount(userId) {
    try {
      if (!userId) {
        throw new Error('User ID is required');
      }

      const { data, count, error } = await supabase
        .from('payment_methods')
        .select('*', { count: 'exact', head: true })
        .eq('user_id', userId);

      if (error) throw error;
      return count || 0;
    } catch (error) {
      console.error('Error getting payment method count:', error);
      throw error;
    }
  }
}; 